module.exports = __webpack_public_path__ + "static/media/tour.fbc755a2.svg";